export default __webpack_public_path__ + "static/services-4-3d237de93f82954bdec4600c6b57e743.jpg";